import { globals } from 'config/globals';


export default {
	behaviours: [],
	particles: [],
	particleBehaviourIndexes: [],
	activeBehaviours: [],
	activeParticles: [],
	activeParticleLength: null,
	activeBehaviourLength: null,
	updateBehavioursFrame: [],
	behaviourProcessCounter: 0,

	needsBehaviourUpdate: false,
	needsParticleUpdate: false,

	isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
	paused: false,
	pingPongMode: false,
	p1: null,
	p2: null,
	pingPongIndex: 0,

	pause() {
		this.paused = true;
	},

	unpause() {
		this.paused = false;
	},

	add(behaviour) {
		this.behaviours.push(behaviour);
		behaviour.index = this.behaviours.length - 1;

		if (behaviour.active) {
			this.activeBehaviours.push(behaviour);
		}

		//Now store the indexes of all behaviours so don't need to loop into find:
		if (!this.particleBehaviourIndexes[behaviour.particleIndex]) {
			this.particleBehaviourIndexes[behaviour.particleIndex] = [];
		}

		if (!this.particleBehaviourIndexes[behaviour.particleIndex].includes(behaviour.index)) {
			this.particleBehaviourIndexes[behaviour.particleIndex].push(behaviour.index);
		}
	},
	getParticleNextLookupIndex() {
		return this.particles.length;
	},
	addParticle(particle, active = true) {
		if (!particle.lookupIndex || particle.lookupIndex == -1) {
			particle.lookupIndex = this.particles.length - 1;
		}

		this.particles.push(particle);

		if (active) {
			this.activeParticles.push(particle);
		}
	},
	setActive(index, active) {
		this.needsBehaviourUpdate = true;
		return;


	},
	setActiveParticle(lookupIndex, active) {
		this.needsParticleUpdate = true;
		return;

		if (lookupIndex == -1) {
			return;
		}

		//Particle swictch means that

		if (active && !this.activeParticles.includes(lookupIndex)) {
			this.activeParticles.push(lookupIndex);
			return;
		}

		if (!active && this.activeParticles.includes(lookupIndex)) {
			var clearIndex = this.activeParticles.indexOf(lookupIndex);
			this.activeParticles.splice(clearIndex, 1);
		}

		//Flag needs update:

	},

	setActivePartcileBehaviourIndexes(particleIndex: number, active: boolean) {
	},

	//Loop through particles +  particle baehaviour:
	//This combines the general tick with the behaviours so not creating loops in loops and checking for active states
	tickActive() {
		if (this.paused) {
			return;
		}

		if (globals.skipNormalParticleUpdates) {
			globals.skipNormalParticleUpdates = false;
			return;
		}

		this.processReseting();
		this.processParticles();
	},

	processReseting() {
		if (this.needsParticleUpdate) {
			this.activeParticles = [];
			for (let i = 0; i < this.particles.length; i++) {
				if (this.particles[i]._active) {
					this.activeParticles.push(this.particles[i]);
				}
			}

			this.activeParticlesLength = this.activeParticles.length;
			this.needsParticleUpdate = false;

		}

		if (this.pingPongMode) {
			let share = Math.round(this.activeParticles.length / 2);
			this.p1 = this.activeParticles.slice(0, share);
			this.p2 = this.activeParticles.slice(share);
		}

		return;
		if (this.needsBehaviourUpdate) {
			this.activeBehaviours = [];
			for (let i = 0; i < this.behaviours.length; i++) {
				if (this.behaviours[i]._active) {
					this.activeBehaviours.push(this.behaviours[i]);
				}
			}
			this.needsBehaviourUpdate = false;
			this.activeBehaviourLength = this.activeBehaviours.length;

		}

		return;

		for (let i = 0; i < this.updateBehavioursFrame.length; i++) {
			for (let j = 0; j < this.particleBehaviourIndexes[this.updateBehavioursFrame[i].particleIndex]; j++) {
				let behaviourIndex = this.particleBehaviourIndexes[this.updateBehavioursFrame[i].particleIndex][j];

				if (this.updateBehavioursFrame[i].active)
					this.setActive(behaviourIndex, this.behaviours[behaviourIndex].active);
				else this.setActive(behaviourIndex, false);
			}
		}

		this.updateBehavioursFrame = [];
	},

	processBehaviours() {


		for (let i = 0; i < this.activeBehaviourLength; i++) {
			this.activeBehaviours[i].tick();
		}

	},
	processParticles() {

		if (this.pingPongMode) {
			let target = this.pingPongIndex == 0 ? this.p1 : this.p2;
			this.pingPongIndex = this.pingPongIndex == 0 ? 1 : 0;

			for (let i = 0; i < target.length; i++) {
				target[i].tick();
			}

			return;
		}

		for (let i = 0; i < this.activeParticlesLength; i++) {
			this.activeParticles[i].tick();
		}

	}
};
